import $ from 'jquery';
import { appconfig } from '../config';

function tryParseJson(value) {
    try {
        return JSON.parse(value);
    } catch (e) {
        return null;
    }
}

export function getOkcSettings(callback, failCallback) {
    var config = appconfig();

    if (!config || !config.pos24ApiBaseUrl) {
        if (callback) callback(null);
        return;
    }

    $.ajax({
        type: 'GET',
        url: config.pos24ApiBaseUrl + '/api/Okc/GetOkcSettings',
        dataType: 'json'
    })
        .done(function (response) {
            if (callback) callback(response);
        })
        .fail(function (xhr, textStatus, errorThrown) {
            console.error('GetOkcSettings fail', xhr);
            if (failCallback) {
                failCallback({
                    xhr: xhr,
                    textStatus: textStatus,
                    errorThrown: errorThrown
                });
            }
        });
}

export function getOnlyTsmEnabled(callback, failCallback) {
    var config = appconfig();

    //console.log('Get only tsm çalıştı');
    //console.log(config);

    if (!config || !config.pos24ApiBaseUrl) {
        if (callback) callback(false);
        return;
    }

    getOkcSettings(
        function (response) {
            //console.log('GetOkcSettings response:', response);

            var items = Array.isArray(response)
                ? response
                : (response && Array.isArray(response.data) ? response.data : []);

            if (!items || items.length === 0) {
                if (callback) callback(false);
                return;
            }

            var inposSetting = items.find(x => Number(x.settingsType) === 0);

            //console.log('Inpos setting:', inposSetting);

            if (!inposSetting || !inposSetting.data) {
                if (callback) callback(false);
                return;
            }

            var parsed = null;

            try {
                parsed = JSON.parse(inposSetting.data);
            } catch (e) {
                console.error('Inpos setting parse error:', e);
                if (callback) callback(false);
                return;
            }

            var tsmModels =
                parsed.InposTsmModels ||
                parsed.inposTsmModels ||
                [];

            var hasValidTsmModel =
                Array.isArray(tsmModels) &&
                tsmModels.some(x =>
                    x &&
                    (
                        (x.tsmMatchId && x.tsmMatchId.trim().length > 5) ||
                        (x.TsmMatchId && x.TsmMatchId.trim().length > 5)
                    )
                );

            if (callback) callback(hasValidTsmModel === true);
        },
        function (error) {
            console.error('GetOkcSettings fail:', error);
            if (failCallback) failCallback(error);
            if (callback) callback(false);
        }
    );
}



// WEBPACK FOOTER //
// ./app/services/okcSettingsService.js